import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import dayjs from "dayjs";
import {useLookupActions} from "../../../service/useLookupActions";
import {useProductCodeActions} from "../../../service/useProductCodeActions";
import {useStatusValuesPromo} from "../../../component/useStatusValuesPromo";
import {
    PROMO_TYPOLOGY_CREDIT_CARD,
    PROMO_TYPOLOGY_SHORT_TERM,
    PROMO_TYPOLOGY_SUBSCRIPTION
} from "../../../component/Constants";
import {useSubscriptionActions} from "../../../service/useSubscriptionActions";
import {intToFloatCurrency} from "../../../component/Utils";

const PromoDetailModal = (props: any) => {
    const {t} = useTranslation(['salesmarketing']);

    const {getStatusLabel} = useStatusValuesPromo();
    const {getRatePlanInfoByProductCode} = useLookupActions();
    const {findProductCode} = useProductCodeActions();
    const {getSubscriptionById} = useSubscriptionActions();
    const [lmsList, setLmsList] = useState<any[]>([]);
    const [dropDmsList, setDropDmsList] = useState<any[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<any>({
        startDate: null,
        endDate: null,
        name: "",
        description: ""
    });
    const [ancillaryNameList, setAncillaryNameList] = useState<any[]>([]);
    const theme = useTheme();
    const {promo} = props;
    const [maxBookings, setMaxBookings] = useState<any>('');
    const [maxUserBookings, setMaxUserBookings] = useState<any>('');
    const [selectedSubscription, setSelectedSubscription] = useState({
        activableStartDate: null,
        activableEndDate: null,
        name: ''
    });




    useEffect(() => {
        if (promo && promo.typology !== PROMO_TYPOLOGY_CREDIT_CARD) {
            getRatePlanInfoByProductCode(promo.productCode[0]).then(res => {
                if (res && res.locationsExt && res.ancillaries) {
                    setLmsList(res.locationsExt);
                    setDropDmsList(res.locationsExt);
                    setAncillaryNameList(res.ancillaries);
                }

            })
            findProductCode(promo.productCode[0]).then(res => {
                if (res) {
                    setSelectedProduct(res);
                }
            })
        } else {
            promo.productCode.forEach((pc: string) => {
                getRatePlanInfoByProductCode(pc).then(res => {
                    if (res && res.locationsExt && res.ancillaries) {
                        setLmsList((prev: any) => [...prev, res.locationsExt]);
                        setDropDmsList((prev: any) => [...prev, res.locationsExt]);
                        setAncillaryNameList((prev: any) => [...prev, res.ancillaries]);
                    }
                });
            });
        }

        if (promo.typology === PROMO_TYPOLOGY_SUBSCRIPTION) {
            getSubscriptionById(promo.subscriptionplanId).then((res: any) => {
                setSelectedSubscription({
                    name: res.name,
                    activableStartDate: res.activableStartDate,
                    activableEndDate: res.activableEndDate
                })
            });
        }

        if(promo.maxBookings !== undefined && promo.maxBookings !== ''){
            setMaxBookings(promo.maxBookings)
        }
        if(promo.maxUserBookings !== undefined && promo.maxUserBookings !== '' ){
            setMaxUserBookings(promo.maxUserBookings)
        }

    }, [promo]);

    const renderShortTerm = () => {
        return (
            <>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.selectedProductName')}
                        value={selectedProduct.name}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.selectedProductDescription')}
                        value={selectedProduct.description}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.selectedProductStartDate')}
                        value={selectedProduct.startDate ? dayjs(selectedProduct.startDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.selectedProductEndDate')}
                        value={selectedProduct.endDate ? dayjs(selectedProduct.endDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.bookingStartDate')}
                        value={promo.bookingStartDate ? dayjs(promo.bookingStartDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.bookingEndDate')}
                        value={promo.bookingEndDate ? dayjs(promo.bookingEndDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.pickupStartDate')}
                        value={promo.pickupStartDate ? dayjs(promo.pickupStartDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.pickupEndDate')}
                        value={promo.pickupEndDate ? dayjs(promo.pickupEndDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.lms')}
                        value={promo.lmsList && lmsList.length > 0 ? promo.lmsList.map((l: any) => lmsList.find((ll: any) => ll.sapId === l)?.name).join(', ') :  "-"}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.dropDms')}
                        value={dropDmsList.length > 0  && lmsList.length ? promo.dropDmsList.map((l: any) => {
                            return lmsList.find((ll: any) => ll.sapId === l)?.name
                        }).join(', ') : "-"}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.acrissCode')}
                        value={promo.acrissCodeList && promo.acrissCodeList.length > 0 ? promo.acrissCodeList.join(", ") : "-"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.description')}
                        value={promo.description ? promo.description : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.promoCode')}
                        value={promo.promoCode ? promo.promoCode : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.discountPercentage')}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">%</InputAdornment>,
                        }}
                        value={promo.discountPercentage ? promo.discountPercentage : '--'}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.discountAmount')}
                        value={promo.discountAmount ? intToFloatCurrency(promo.discountAmount) : '--'}

                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.maxBooking')}
                        value={maxBookings}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.maxBookingsForUser')}
                        value={maxUserBookings}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        inputProps={{readOnly: true}}
                        label={t('promo.freeDays')}
                        value={promo.freeDays}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        inputProps={{readOnly: true}}
                        label={t('promo.minDurationForFreeDays')}
                        value={promo.minimumDurationForFreeDays}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        inputProps={{readOnly: true}}
                        label={t('promo.minDuration')}
                        value={promo.minimumDuration}
                    />
                </Grid>
            </>
        )
    }

    const renderCreditCard = () => {
        return (
            <>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.bookingStartDate')}
                        value={promo.bookingStartDate ? dayjs(promo.bookingStartDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.bookingEndDate')}
                        value={promo.bookingEndDate ? dayjs(promo.bookingEndDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.pickupStartDate')}
                        value={promo.pickupStartDate ? dayjs(promo.pickupStartDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.pickupEndDate')}
                        value={promo.pickupEndDate ? dayjs(promo.pickupEndDate).format("L") : ""}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        margin="dense"
                        id="lms"
                        label={t('promo.binCodes')}
                        fullWidth
                        variant="standard"
                        value={promo.binCode && promo.binCode.length > 0 ? promo.binCode.join(', ') : ""}
                        inputProps={
                            {readOnly: true}
                        }
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.description')}
                        value={promo.description ? promo.description : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.discountPercentage')}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">%</InputAdornment>,
                        }}
                        value={promo.discountPercentage ? promo.discountPercentage : '--'}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.discountAmount')}
                        value={promo.discountAmount ? promo.discountAmount : '--'}

                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.maxBooking')}
                        value={maxBookings}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.maxBookingsForUser')}
                        value={maxUserBookings}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        inputProps={{readOnly: true}}
                        label={t('promo.freeDays')}
                        value={promo.freeDays}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        inputProps={{readOnly: true}}
                        label={t('promo.minDurationForFreeDays')}
                        value={promo.minimumDurationForFreeDays}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        inputProps={{readOnly: true}}
                        label={t('promo.minDuration')}
                        value={promo.minimumDuration}
                    />
                </Grid>
            </>
        );
    }

    const renderSubscription = () => {
        return (
            <>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.selectedProductName')}
                        value={selectedProduct.name}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.selectedProductDescription')}
                        value={selectedProduct.description}
                    />
                </Grid>
                <Grid item xs={6}/>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.subscription')}
                        value={selectedSubscription.name}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.sku')}
                        value={promo.sku}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        label={t('promo.subscriptionStartDate')}
                        value={selectedSubscription.activableStartDate ? dayjs(selectedSubscription.activableStartDate).format("L") : ''}
                        inputProps={{readOnly: true}}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        label={t('promo.subscriptionEndDate')}
                        value={selectedSubscription.activableEndDate ? dayjs(selectedSubscription.activableEndDate).format("L") : ''}
                        fullWidth
                        inputProps={{readOnly: true}}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        InputProps={{startAdornment: <InputAdornment position="start">%</InputAdornment>}}
                        fullWidth
                        label={t('promo.monthlyFeeDiscountPercentage')}
                        value={promo.monthlyFeeDiscountPercentage ? promo.monthlyFeeDiscountPercentage : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.monthlyFeeDiscountAmount')}
                        value={promo.monthlyFeeDiscountAmount ? intToFloatCurrency(promo.monthlyFeeDiscountAmount) : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.numberOfMonths')}
                        value={promo.numberOfMonths ? promo.numberOfMonths : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.monthlyStartDate')}
                        value={promo.monthlyStartDate ? dayjs(promo.monthlyStartDate).format("L HH:mm") : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.monthlyEndDate')}
                        value={promo.monthlyEndDate ? dayjs(promo.monthlyEndDate).format("L HH:mm") : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.description')}
                        value={promo.description ? promo.description : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.promoCode')}
                        value={promo.promoCode ? promo.promoCode : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        InputProps={{startAdornment: <InputAdornment position="start">%</InputAdornment>}}
                        fullWidth
                        label={t('promo.yearlyFeeDiscountPercentage')}
                        value={promo.yearlyFeeDiscountPercentage ? promo.yearlyFeeDiscountPercentage : ''}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        inputProps={{readOnly: true}}
                        fullWidth
                        label={t('promo.yearlyFeeDiscountAmount')}
                        value={promo.yearlyFeeDiscountAmount ? intToFloatCurrency(promo.yearlyFeeDiscountAmount) : ''}
                    />
                </Grid>
            </>
        );
    }

    return (
        promo && <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={props.open}
                         onClose={() => {
                             return;
                         }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('promo.details')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        props.handleClose();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('promo.status')}
                            fullWidth
                            variant="standard"
                            value={getStatusLabel(promo.statusCode)}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="type"
                            label={t('promo.visibility')}
                            fullWidth
                            variant="standard"
                            value={getStatusLabel(promo.visibility)}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="type"
                            label={t('promo.typology')}
                            fullWidth
                            variant="standard"
                            value={getStatusLabel(promo.typology)}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('promo.productCode')}
                            fullWidth
                            variant="standard"
                            value={promo.productCode.join(', ')}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    {promo.typology === PROMO_TYPOLOGY_SHORT_TERM && renderShortTerm()}
                    {promo.typology === PROMO_TYPOLOGY_CREDIT_CARD && renderCreditCard()}
                    {promo.typology === PROMO_TYPOLOGY_SUBSCRIPTION && renderSubscription()}
                </Grid>
                <Grid container spacing={5} sx={{padding: "15px"}} justifyContent={"space-between"}>
                    {promo.subperiodList && promo.subperiodList.length > 0 && <Grid container item xs={12}>
                        <Typography>
                            {t('promo.subPeriods.title')}
                        </Typography>
                        <TableContainer sx={{paddingTop: "10px"}}>
                            <Table aria-label="subPeriods-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('promo.subPeriods.startDate')}</TableCell>
                                        <TableCell>{t('promo.subPeriods.endDate')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {promo.subperiodList.map((row: any, index: number) => (
                                        <TableRow
                                            key={"sub" + index}
                                        >
                                            <TableCell>{dayjs(row.startDate).format("L")}</TableCell>
                                            <TableCell>{dayjs(row.endDate).format("L")}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>}
                    {ancillaryNameList.length > 0 && promo.ancillaryList && promo.ancillaryList.length > 0 &&
                        <Grid item xs={promo.typology===PROMO_TYPOLOGY_SUBSCRIPTION ? 12 : 6}>
                            <Typography>
                                {t('promo.ancillaryPromo.title')}
                            </Typography>
                            <TableContainer sx={{paddingTop: "10px"}}>
                                <Table aria-label="ancillaryPromo-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('promo.ancillaryPromo.name')}</TableCell>
                                            <TableCell>{t('promo.ancillaryPromo.discount')}</TableCell>
                                            <TableCell>{t('promo.ancillaryPromo.amount')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {promo.ancillaryList.map((row: any, index: number) => (
                                            <TableRow
                                                key={"anc" + index}
                                            >
                                                <TableCell>{ancillaryNameList.find((aa:any) => aa.id === parseInt(row.ida))?.name}</TableCell>
                                                <TableCell>{row.discount ? ("%" + row.discount) : "--"}</TableCell>
                                                <TableCell>{row.amount ? intToFloatCurrency(row.amount): '--'}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>}
                    {promo.earlyBookingList && promo.earlyBookingList.length > 0 && <Grid item xs={6}>
                        <Typography>
                            {t('promo.earlyBookings.title')}
                        </Typography>
                        <TableContainer sx={{paddingTop: "10px"}}>
                            <Table aria-label="ancillaryPromo-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('promo.earlyBookings.early')}</TableCell>
                                        <TableCell>{t('promo.earlyBookings.discount')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {promo.earlyBookingList.map((row: any, index: number) => (
                                        <TableRow
                                            key={"ear" + index}
                                        >
                                            <TableCell>{row.early}</TableCell>
                                            <TableCell>{"%" + (row.discount ? row.discount : "")}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color={"accent"}
                        onClick={() => props.handleClose()}>{t('promo.buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    );

}

export default PromoDetailModal;